export default __webpack_public_path__ + "static/media/sign up expert1.b317b50e.png";